import { Injectable } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { RegistrationPageComponent } from '../pages/registration-page/registration-page.component';

/**
 * Opens the registration page as a modal. Kept separate from LoginService to
 * avoid a circular import (RegistrationPageComponent itself uses LoginService).
 */
@Injectable({ providedIn: 'root' })
export class RegistrationModalService {
  private modalRef: MdbModalRef<RegistrationPageComponent> | null = null;

  constructor(private modalService: MdbModalService) {}

  open(): void {
    if (this.modalRef) {
      return;
    }
    this.modalRef = this.modalService.open(RegistrationPageComponent, {
      // no modal-dialog-centered: top-aligned so it sits in the upper part
      // of the viewport
      modalClass: 'registration-modal-dialog',
      data: { openedAsModal: true },
    });
    this.modalRef.onClose.subscribe(() => (this.modalRef = null));
  }
}
